import { useEffect } from 'react';
import { handleMsgOnCommonField } from '../../utils';
import { OtherFieldView } from './OtherFieldView';
import { useInitOtherField } from '../../hooks/useInitApp';
import { useSearchParams } from 'react-router-dom';

export const OtherFieldContainer = () => {
  const [search] = useSearchParams();
  const fieldType = search.get('field') ?? '';

  const { isInit, ...params } = useInitOtherField({ fieldType });

  useEffect(() => {
    window.addEventListener('message', handleMsgOnCommonField);
    return () => {
      window.removeEventListener('message', handleMsgOnCommonField);
    };
  }, []);

  return isInit ? <OtherFieldView {...params} /> : <></>;
};
